import API from "../utils/api";

export const getFrasersPaymentsApi = async (params) => {
    const response = await API.get("order/frasers-plus-payments", { params });
    return { response };
};

export const getFrasersPaymentByIdApi = async (id) => {
    const response = await API.get(`order/frasers-plus-payments/${id}`);
    return { response };
};

export const refreshFrasersPaymentApi = async (id) => {
    const response = await API.post(`order/frasers-plus-payments/${id}/refresh`);
    return { response };
};
